module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.6d1796a.ttf";